import React from "react";
import type { FeatureKey } from "../types";
import { FEATURE_LABELS } from "../types";

interface FeatureUpgradeModalProps {
  isOpen: boolean;
  onClose: () => void;
  featureKey: FeatureKey;
}

const UPGRADE_MESSAGE =
  "This feature is available on the Sagelyn Pro plan. Upgrade from Starter to unlock.";

export const PRICING_PAGE_URL = "https://www.sagelyn.ai/pricing";

export const FeatureUpgradeModal: React.FC<FeatureUpgradeModalProps> = ({
  isOpen,
  onClose,
  featureKey,
}) => {
  if (!isOpen) return null;

  const featureLabel = FEATURE_LABELS[featureKey] ?? featureKey;

  const handleUpgrade = () => {
    window.open(PRICING_PAGE_URL, "_blank", "noopener,noreferrer");
    onClose();
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="feature-upgrade-title"
    >
      <div
        className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h3
          id="feature-upgrade-title"
          className="text-lg font-semibold text-[#2f4941] mb-2"
        >
          Upgrade to use {featureLabel}
        </h3>
        <p className="text-sm text-[#2f4941]/80 mb-6">{UPGRADE_MESSAGE}</p>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-[#2f4941] border border-[#e0dbcf] rounded-lg hover:bg-[#f5f3ec] transition-colors"
          >
            Close
          </button>
          <button
            type="button"
            onClick={handleUpgrade}
            className="px-4 py-2 bg-[#2f4941] text-white rounded-lg hover:bg-[#1e3128] transition-colors"
          >
            Upgrade
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureUpgradeModal;
